import * as React from 'react';
import classNames from 'classnames';
import * as moment from 'moment';

import DatePicker from 'react-datepicker/es';
import { Grid } from '@material-ui/core';
import SubTooltip from '../Tooltip/SubTooltip';

import * as DiscardIcon from '../../../../assets/image/discard.png';
import * as SubmitIcon from '../../../../assets/image/submitForm.png';

interface Props {
  isEditing: boolean;
  editExistSubDatetimeFinishValue: Date;
  onSaveEditMenu: () => void;
  onDiscardEditMenu: () => void;
  editExistSubDatetimeFinish: (id: number) => void;
}

function ExistSubEdit (props: Props) {

  const [existSubEditFieldset, setExistSubEditFieldset] = React.useState(classNames('exist-sub-edit-fieldsset'));
  
  React.useEffect(() => {
    setTimeout(changeExistSubEditFieldset, 100);
  }, []);

  const changeExistSubEditFieldset = React.useCallback(() => {
    setExistSubEditFieldset(classNames('exist-sub-edit-fieldsset',
      'exist-sub-edit-fieldsset-open'
    ));
  }, []);

  const handleChange = React.useCallback((e) => {
    if (e) {
      props.editExistSubDatetimeFinish(
        // @ts-ignore
        `${moment(e).format().slice(0, 11)}00:00:00Z`
      );
    }
  }, [props.editExistSubDatetimeFinish]);
  
  return (
    <Grid container>

      <fieldset className={existSubEditFieldset}>
        <legend className='sub-main-color exist-sub-edit-legend'>
          {'New Subscription Paramters'}
        </legend>

        <Grid
          className='new-parameters-wrapper'
          container>
          <Grid
            item
            lg={3} >
            <div className='first-new-parameter'>
              {'Date finish:'}
            </div>
          </Grid>
          <Grid
            item
            lg={4} >
            <DatePicker
              showYearDropdown
              onChange={handleChange}
              className=''
              dateFormat='dd.MM.yyyy'
              placeholderText='date'
              selected={props.editExistSubDatetimeFinishValue
                ? new Date(props.editExistSubDatetimeFinishValue) : null}
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            lg={1} />
          <Grid
            item
            lg={1}>
            <button
              className='sub-clear-btn sub-exist-form-image:'
              onClick={props.onDiscardEditMenu}
            >
              <SubTooltip
                placement='left'
                title='Discard'
                wrappedNode={
                  <img
                    className='sub-exist-edit-image sub-exist-edit-image-discard  sub-exist-form-image cursor-pointer'
                    src={DiscardIcon}
                    alt='' />
                } />
            </button>
          </Grid>
          <Grid
            item
            lg={1} />
          <Grid
            item
            lg={1}>
            <button
              className='sub-clear-btn'
              onClick={props.onSaveEditMenu}
            >
              <SubTooltip
                placement='right'
                title='Submit'
                wrappedNode={
                  <img
                    className='sub-exist-edit-image sub-exist-edit-image-save sub-exist-form-image cursor-pointer'
                    src={SubmitIcon}
                    alt='' />
                } />
            </button>
          </Grid>
          <Grid
            item
            lg={8} />
        </Grid>
      </fieldset>
    </Grid>
  );
  
}

export default React.memo(ExistSubEdit);
